const hasUnsafeCharacters = (value) =>
  Array.from(value).some(
    (character) =>
      character === "\\" ||
      character.charCodeAt(0) <= 32 ||
      character.charCodeAt(0) === 127,
  );
export const safeInternalRedirect = (value) => {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    hasUnsafeCharacters(value)
  )
    return null;
  try {
    const decoded = decodeURIComponent(value);
    if (
      decoded.startsWith("//") ||
      hasUnsafeCharacters(decoded) ||
      /^\/(?:login|auth)(?:[/?#]|$)/i.test(decoded)
    )
      return null;
  } catch {
    return null;
  }
  return value;
};
